import { DomainError } from '../errors/domain-error';

export const GROWTH_RECOMMENDATION_MAX_PER_PUBLICATION = 5;

export const GrowthRecommendationVerificationLabel = {
  RECOMMENDATION: 'recommendation',
  SELF_RECOMMEND: 'self_recommend',
  PLACEMENT_DISABLED: 'placement_disabled',
  UNKNOWN_SOURCE: 'unknown_source',
  DUPLICATE: 'duplicate',
} as const;

export type GrowthRecommendationVerificationLabelValue =
  (typeof GrowthRecommendationVerificationLabel)[keyof typeof GrowthRecommendationVerificationLabel];

export function buildPublicationRecommendationPath(
  toSlug: string,
  fromSlug: string,
): string {
  return `/n/${toSlug}/subscribe?rec=${encodeURIComponent(fromSlug)}`;
}

export function assertCanRecommendPublication(params: {
  fromPublicationId: string;
  toPublicationId: string;
}): void {
  if (params.fromPublicationId === params.toPublicationId) {
    throw new DomainError('A publication cannot recommend itself');
  }
}

export function canApplyPublicationRecommendation(params: {
  enabled: boolean;
  fromPublicationId: string;
  toPublicationId: string;
}): boolean {
  if (!params.enabled) return false;
  if (params.fromPublicationId === params.toPublicationId) return false;
  return true;
}
